<template>
  <div class="table-top-btns">
    <el-badge :value="btn.tag" v-for="(btn, btnindex) in btnsList" :key="btnindex">
      <el-popover trigger="hover" popper-class="top-user-popover" placement="bottom-start" v-if="btn.dropList" :key="btnindex">
        <el-button class="table-top-btn primary-border" slot="reference" type="primary">
          <el-tooltip v-if="btn.tooltip" effect="light" :content="btn.tooltip" placement="top-start" :key="btnindex">
            <span>{{ btn.text }}</span>
          </el-tooltip>
          <span v-else>{{ btn.text }}</span>
          <i class="el-icon-arrow-down" />
        </el-button>
        <div class="drop-list">
          <template v-for="(item, itindex) in btn.dropList">
            <div v-if="item && item.text" :key="itindex" class="drop-list-item" @click="btnclick(item)">
              <el-tooltip v-if="item.tooltip" effect="light" :content="item.tooltip" placement="right" :key="itindex">
                <span>{{ item.text }}</span>
              </el-tooltip>
              <span v-else>{{ item.text }}</span>
              <el-badge v-if="item.text === '查询诊断商品'" class="mark" :value="suggestionTotalCount" />
            </div>
          </template>
        </div>
      </el-popover>
      <el-tooltip v-else-if="btn.tooltip" effect="light" :content="btn.tooltip" placement="top-start" :key="btnindex">
        <el-button class="table-top-btn primary-border" type="primary" @click="btnclick(btn)">
          {{ btn.text }}
        </el-button>
      </el-tooltip>
      <el-button v-else :key="btnindex" class="table-top-btn primary-border" type="primary" @click="btnclick(btn)">
        {{ btn.text }}
      </el-button>
    </el-badge>
  </div>
</template>

<script>
import {DISTRIBUTION_BTNS_LIST , SUPPLIER_BTNS_LIST} from "./dictionary.js"
import { mapActions } from 'vuex';
export default {
  props:{
    mode: {
      type: String,
      default: 'supplier'
    },
    btns: {
      type: Array,
      default: () => []
    },
    searchType:{
      type: Number,
      default: 1
    }
  },
  data() {
    return {
    };
  },
  computed:{
    btnsList(){
      if(this.btns && this.btns.length) {
        return this.btns;
      }
      if(this.mode === "distributor") {
        let btns = DISTRIBUTION_BTNS_LIST()
        if(this.searchType === 2){
          // 按sku查询 只展示批量操作按钮
          btns = btns.filter(i => i.text === '批量操作' || i.text === "转为分销商品")
          btns.forEach(item => {
            if(item.text === '批量操作'){
              item.dropList = item.dropList?.filter(it => !['修改类目和属性','批量设置商品标签','批量关联素材包','批量解除关联'].includes(it.text))
            }
          })
        }
        return btns
      } else {
        let featureCodes = this.$store.getters.featureCodes;
        let showPutGoods = featureCodes?.includes('PublicSourceReport');
        let joinOcean = this.$store.getters.getJoinOcean;
        let btns = SUPPLIER_BTNS_LIST();
        if (!showPutGoods || !joinOcean) {
            btns = btns.filter(btn => btn.text !== '提报货源');
        }
        if(this.searchType === 2){
            // 按sku查询 只展示批量操作按钮
          btns = btns.filter(i => i.text === '批量操作')
          btns.forEach(item => {
            if(item.text === '批量操作'){
              item.dropList = item.dropList?.filter(it => !['修改类目和属性','批量设置商品标签','批量关联素材包','批量解除关联'].includes(it.text))
            }
          })
        }
        
        return btns;
      }
    },
    suggestionTotalCount() {
      return this.$store.getters.suggestionTotalCount;
    }
  },
  methods: {
    ...mapActions(['startSuggestionPolling', 'fetchSuggestionResultAction']),
    btnclick(btn) {
      this.$emit("click", btn.eventName, btn.config || {});
    },
    async requestFxgSuggestionData() {
      await this.startSuggestionPolling();
      this.fetchSuggestionResultAction();
    }
  },
  mounted() {
    this.requestFxgSuggestionData();
  }
};
</script>

<style lang="scss" scoped>
.table-top-btns {
  margin-top: 8px;
  margin-bottom: 8px;
}
.el-icon-arrow-down {
  vertical-align: initial;
  margin-left: 5px;
}
.table-top-btn {
  margin-right: 8px;
  margin-bottom: 8px;
}
.drop-list {
  .drop-list-item {
    cursor: pointer;
    padding: 0 10px;
    height: 28px;
    line-height: 28px;
    &:hover {
      background: #f5f5f5;
    }
    .icon {
      margin-right: 5px;
      vertical-align: baseline;
    }
  }
  .drop-list-item + .drop-list-item {
    margin-top: 3px;
  }
}
.top-user-popover {
  padding: 5px 0;
  font-size: 14px;
}
.el-button + .el-button {
  margin-left: 0;
}
::v-deep .el-badge__content{
  z-index: 99;
}
::v-deep .el-badge__content.is-fixed{
  right: 40px;
  top:-3px;
}
</style>
